import i18next from 'i18next';
import { translate } from 'react-i18next';
import moment from 'moment';
import _ from 'lodash';
import {
  BetTypeGroup, EventOrder, DEFAULT_DATES,
  OddsFormatTrans, OptionKeys, OddsMode, OddsFormatMB,
  MarketFilterTrans, Market, Mode, PLAYER_TYPE
} from '../../../common/Foundation';
import CommonUtil from '../../../common/CommonUtil';
import { selectLeagueOptionKeys } from './constants';

@translate([], { wait: true })
export default class ViewOptionsAction {
  
  static translate(key) {
    return i18next.t(key)
  }

  static convertOddsMode(key) {
    return key === 'double' ? OddsMode.Double : OddsMode.Single;
  }

  static convertSort(key) {
    return key === 'sort-time' ? EventOrder.Time : EventOrder.League;
  }

  static getMarketText(key) {
    const marketText = MarketFilterTrans[key] ? MarketFilterTrans[key] : '';
    return this.translate(`default:${marketText}`);
  }

  static getOddsFormatText(key) {
    const oddsFormatText = OddsFormatTrans[key] ? OddsFormatTrans[key] : '';
    return this.translate(`default:${oddsFormatText}`);
  }

  static getDateRanges(numberOfDates = 5, timeZoneOffset = -240) {
    const generateDates = CommonUtil.generateDates(numberOfDates, timeZoneOffset);
    let priority = 0;
    const dates = _.concat(DEFAULT_DATES,
      _.map(generateDates, (date, index) => {
        const { value } = date;
        return {
          text: value,
          value: value,
          priority: priority += 1
        };
      })
    );

    return _.orderBy(dates, ['priority']);
  }

  static convertTeaserDateRanges(teaserDates) {
    let priority = 0;
    const dates = _.concat([DEFAULT_DATES[0]],
      _.map(teaserDates, (teaserDate, index) => {
        const filterDate = teaserDate[2];
        return {
          text: filterDate,
          value: filterDate,
          priority: priority += 1
        };
      })
    );

    return _.orderBy(dates, ['priority']);
  }

  static getTimeRanges(timeZoneOffset) {
    const timeZone = timeZoneOffset == null ? -(new Date().getTimezoneOffset()) : timeZoneOffset;

    let today = moment().utcOffset("-04:00");
    const hour = parseInt(today.hour() / 4, 10) * 4;
    
    let timeRanges = {};
    timeRanges[0] = this.translate("default:All Times");

    for (let i = 1; i <= 6; i++) {
      today = moment().utcOffset("-04:00");
      const fromHour = hour + (i - 1) * 4;
      
      let from = today.hour(fromHour).utcOffset(timeZone);
      from = i === 1 ? this.translate('default:Now') : from.format(this.translate("format:hh A"));
      
      timeRanges[i] = `${from} - ${today.add(4, 'h').utcOffset(timeZone).format(this.translate("format:hh A"))}`;
    }

    return timeRanges;
  }

  static isOutright(mode) {
    return mode === Mode.OUTRIGHT || mode === Mode.OUTRIGHT_MARKET;
  }

  static isParlay(mode) {
    return mode === Mode.PARLAY;
  }

  static isTeaser(mode) {
    return mode === Mode.TEASER_MARKET || mode === Mode.TEASER;
  }

  static filterViewOptions(options, filter) {
    const { mode, market, betTypeGroup } = filter;

    let ignoreOptions = [];
    if (this.isTeaser(mode)) {
      // Filter options to teaser
      ignoreOptions = [OptionKeys.line, OptionKeys.odds];
    } else if (this.isParlay(mode)) {
      ignoreOptions = [OptionKeys.time];
    } else {
      if (market === Market.Early || mode === Mode.INPLAY) {
        // Filter options to early and inplay
        ignoreOptions = [OptionKeys.time];
      } else if (market === Market.ALL && (betTypeGroup === BetTypeGroup.TEAM_TOTAL || betTypeGroup === BetTypeGroup.ML_1X2)) {
        // Filter options to team totals and 1x2
        ignoreOptions = [OptionKeys.time, OptionKeys.view];
      }
    }

    if (!_.isEmpty(ignoreOptions)) {
      return _.filter(options, option => !ignoreOptions.includes(option.key));
    }

    return options;
  }

  static getViewOptionKeys(filter) {
    const { mode, market, betTypeGroup} = filter;
    if (!this.isOutright(mode)) {
      let ignoreOptions = [OptionKeys.date];
      if (this.isTeaser(mode)) {
        // Filter options to teaser
        ignoreOptions = [OptionKeys.line, OptionKeys.odds];
      } else if (this.isParlay(mode) || mode === Mode.INPLAY) {
        ignoreOptions = _.concat(ignoreOptions, [OptionKeys.time]);
      } else {
        if (market === Market.Early) {
          // Filter options to early and inplay
          ignoreOptions = [OptionKeys.time];
        } else if (market === Market.ALL && (betTypeGroup === BetTypeGroup.TEAM_TOTAL || betTypeGroup === BetTypeGroup.ML_1X2)) {
          // Filter options to team totals and 1x2
          ignoreOptions = _.concat(ignoreOptions, [OptionKeys.time, OptionKeys.view]);
        }
      }
      return _.difference(Object.values(OptionKeys), ignoreOptions);
    }

    return [OptionKeys.odds];
  }

  static buildOptionsToSelectLeague(data, isSelectedHighlight, searchSportId, leagueIdSearch) {
    const options = {
      isSelectedHighlight: isSelectedHighlight,
      searchSportId: searchSportId,
      searchLeagueId: leagueIdSearch
    };

    if (data) {
      const { outright, eSports, filterOptions } = selectLeagueOptionKeys
      _.forEach(selectLeagueOptionKeys, (value, key) => {
        if (value === outright) {
          options[outright] = {
            sportId: _.get(data, 'outright.sportId'),
            outrightType: _.get(data, 'outright.outrightType')
          }
        } else if (value === eSports) {
          options[eSports] = {
            eSportId: _.get(data, 'eSports.eSportId'),
            eSportCode: _.get(data, 'eSports.eSportCode')
          }
        } else if (value === filterOptions) {
          options[filterOptions] = {
            selectedDate: _.get(data, 'filterOptions.selectedDate')
          }
        } else {
          options[value] = data[value];
        }
      });
    }

    return options;
  }
}


// WEBPACK FOOTER //
// ./src/app/components/CompactView/ViewOptionsComponent/ViewOptionsAction.js